import Article from './article.container'

export default Article